export enum FabricStatus {
  /** 未推广 */
  NotPromoted = 1,
  /** 审核中 */
  UnderReview = 2,
  /** 推广中 */
  Promoting = 3,
  /** 已结束 */
  Ended = 4,
  /** 不通过 */
  Rejected = 5,
}

export enum FabricSaleType {
  /** 期货 */
  Futures = 2,
  /** 现货 */
  Spot = 1,
}
/** 关联状态 0-未关联 1-已关联 */
export enum FabricAssociationStatus {
  /** 未关联 */
  NotAssociated = 0,
  /** 已关联 */
  Associated = 1,
}
/** 推广状态 0-已关联已投放 1-已关联未投放 2-未关联未投放 */
export enum FabricPromotionStatus {
  /** 已关联已投放 */
  AssociatedAndPromoted = 0,
  /** 已关联未投放 */
  AssociatedAndNotPromoted = 1,
  /** 未关联未投放 */
  NotAssociatedAndNotPromoted = 2,
}

export enum SourceChannel {
  SHOP = 0,
  /** 淘宝商品 */
  TAOBAO_ITEM = 1,
  /** 抖音商品 */
  DOUYIN_ITEM = 2,
  /** 秀场 */
  RUNWAY = 3,
  /** 站点 */
  SITE = 4,
  /** INS */
  INS = 5,
  /** 小红书 */
  XIAOHONGSHU = 6,
  /** Shein */
  SHEIN = 7,
  /** 图像识别 */
  IMAGE = 8,
  /** Temu */
  TEMU = 9,
  /** 亚马逊 */
  AMAZON = 10,
  /** 跨境独立站 */
  CROSS_BORDER = 11,
}
export const SourceChannelMap = new Map([
  [SourceChannel.SHOP, '店铺'],
  [SourceChannel.TAOBAO_ITEM, '淘宝'],
  [SourceChannel.DOUYIN_ITEM, '抖音'],
  [SourceChannel.RUNWAY, '秀场'],
  [SourceChannel.SITE, '站点'],
  [SourceChannel.INS, 'INS'],
  [SourceChannel.XIAOHONGSHU, '小红书'],
  [SourceChannel.SHEIN, 'SHEIN'],
  [SourceChannel.IMAGE, '图像识别'],
  [SourceChannel.TEMU, 'TEMU'],
  [SourceChannel.AMAZON, '亚马逊'],
  [SourceChannel.CROSS_BORDER, '跨境独立站'],
])

/** 商品上下架状态 */
export enum FabricShelfStatus {
  /** 全部 */
  All = '',
  /** 审核驳回 */
  Rejected = '1',
  /** 已下架 */
  OffShelf = '2',
  /** 在售 */
  OnSale = '3',
  /** 审核中 */
  UnderReview = '4',
}

export enum RecommendFabricStatus {
  Yes = 1,
  No = 0,
}

export enum PromotionStatus {
  /** 未审核 */
  NotAudited = 1,
  /** 审核中 */
  UnderReview = 2,
  /** 审核驳回 */
  Rejected = 3,
  /** 进行中 */
  InProgress = 4,
  /** 已暂停 */
  Paused = 5,
  /** 已结束 */
  Ended = 6,
  /** 未开始 */
  NotStarted = 7,
}

export const PromotionStatusMap = new Map([
  [PromotionStatus.NotAudited, '未审核'],
  [PromotionStatus.UnderReview, '审核中'],
  [PromotionStatus.Rejected, '审核驳回'],
  [PromotionStatus.InProgress, '进行中'],
  [PromotionStatus.Paused, '已暂停'],
  [PromotionStatus.Ended, '已结束'],
  [PromotionStatus.NotStarted, '未开始'],
])

export enum AlunchTypes {
  /** 精准投放 */
  Precision = 1,
  /** 智能投放 */
  Smart = 2,
}

export const AlunchTypesMap = new Map([
  [AlunchTypes.Precision, '精准投放'],
  [AlunchTypes.Smart, '智能投放'],
])

export enum PromotionOperationTypes {
  /** 提交审核 */
  Submit = 1,
  /** 取消审核 */
  Cancel = 2,
  /** 暂停 */
  Pause = 3,
  /** 开启 */
  Start = 4,
  /** 结束 */
  End = 5,
}

export enum PromotionEndReasonTypes {
  /** 项目消费次数用尽 */
  ProjectUseUp = 1,
  /** 团队消费次数用尽 */
  GroupUseUp = 2,
  /** 项目到期 */
  Expire = 3,
  /** 面料下架 */
  FabricDown = 4,
  /** 团队到期 */
  TeamExpire = 5,
  /** 管理员取消 */
  AdminCancel = 6,
  /** 用户取消 */
  UserCancel = 7,
  /** 变更面料信息 */
  ChangeFabric = 8,
}

export const PromotionEndReasonTypesMap = new Map([
  [PromotionEndReasonTypes.ProjectUseUp, '项目消费次数用尽'],
  [PromotionEndReasonTypes.GroupUseUp, '团队消费次数用尽'],
  [PromotionEndReasonTypes.Expire, '项目到期'],
  [PromotionEndReasonTypes.FabricDown, '面料下架'],
  [PromotionEndReasonTypes.TeamExpire, '团队到期'],
  [PromotionEndReasonTypes.AdminCancel, '管理员取消'],
  [PromotionEndReasonTypes.UserCancel, '用户取消'],
  [PromotionEndReasonTypes.ChangeFabric, '变更面料信息'],
])

export enum PromotionFabricStatus {
  Yes = 1,
  No = 0,
}
